/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Summary/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Charges from './Charges/index'
import Discounts from './Discounts/index'
import HorizontalDivider from 'DesignSystem/HorizontalDivider/index'
import InsuranceSummary from './InsuranceSummary/index'
import Insurances from './Insurances/index'
import Payors from './Payors/index'
import React from 'react'
import Remaining from './Remaining/index'
import TotalTreatmentFee from './TotalTreatmentFee/index'
import TreatmentFee from './TreatmentFee/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Summary({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/Summary"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
  return (<React.Fragment
>
<div
  data-testid="Summary.Vertical"
  data-view-path={viewPath}
 style={{'--pt-1-ZdVelx': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pb-2-ZdVelx': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pl-3-ZdVelx': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-4-ZdVelx': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h4"
 text="Treatment Fee Summary"
 marginLeft={dtSpaceXs}
 marginRight={dtSpaceXs}
/>
<TreatmentFee
  viewPath={`${viewPath}/TreatmentFee`}
/>
<Charges
  viewPath={`${viewPath}/Charges`}
/>
<Discounts
  viewPath={`${viewPath}/Discounts`}
/>
<TotalTreatmentFee
  viewPath={`${viewPath}/TotalTreatmentFee`}
/>
<InsuranceSummary
  viewPath={`${viewPath}/InsuranceSummary`}
/>
<div
  data-testid="Summary.Horizontal"
  data-view-path={viewPath}
 style={{'--pl-3-ZdVelx': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-4-ZdVelx': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--mt-5-ZdVelx': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs}}
 className={`views-block ${styles.Horizontal}`}
>
<HorizontalDivider
  viewPath={`${viewPath}/HorizontalDivider`}
/>
</div>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h4"
 marginTop={dtSpaceS}
 marginLeft={dtSpaceXs}
 marginRight={dtSpaceXs}
 text="Payor summary"
/>
<Insurances
  viewPath={`${viewPath}/Insurances`}
/>
<Payors
  viewPath={`${viewPath}/Payors`}
/>
<div
  data-testid="Summary.Horizontal:1"
  data-view-path={viewPath}
 style={{'--pl-3-ZdVelx': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-4-ZdVelx': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal1}`}
>
<HorizontalDivider
  viewPath={`${viewPath}/HorizontalDivider`}
/>
</div>
<Remaining
  viewPath={`${viewPath}/Remaining`}
/>
</div>
{children}
</React.Fragment>)
}